import { render, staticRenderFns } from "./SelectContainerType.vue?vue&type=template&id=3af85502&scoped=true"
import script from "./SelectContainerType.vue?vue&type=script&lang=ts"
export * from "./SelectContainerType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af85502",
  null
  
)

export default component.exports